<script>
import BaseEditable from '../base-editable/base-editable.vue';
import { SIZES, VARIANTS } from './options.js';

export default {
  name: 'BaseInput',
  extends: BaseEditable,
  inject: {
    $parentInstance: { default: undefined },
  },
  props: {
    size:     { type: String,    default: 'default',    validator: (x) => SIZES.includes(x) },
    variant:  { type: String,    default: 'default',    validator: (x) => VARIANTS.includes(x) },
  },
};
</script>
